import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ReportTenantsMapService } from './reports-tenants-map-view.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ReportService } from '../../services/report.service';
import { ReportsChartEnum, ReportsViewEnum } from '../../models/enums/reports.enum';
import { SharedService } from 'src/app/common/services/shared.service';
import { environment } from 'src/environments/environment';
import { actionIdConstants } from 'src/app/common/constants/common.contants';
import { UserService } from 'src/app/common/services/user.service';
import { activityPayload } from 'src/app/common/models/userActivity.model';
import { ActivatedRoute, Router } from '@angular/router';

declare const L: any;
export interface SelectedTenant {
  tenant_name: string;
  floor_uid:string
}
@Component({
  selector: 'app-reports-tenants-map-view',
  templateUrl: './reports-tenants-map-view.component.html',
  styleUrls: ['./reports-tenants-map-view.component.scss']
})

export class ReportsTenantsMapViewComponent {

  @Input() classname!: string;
  zoomControl: any;
  selected_tenant!:SelectedTenant;
  public mapCenter: any = [29.3560456, 47.9999959];
  @Input() set propertyInfo(value: any) {
    if (value) {
      this.selected_property = value;
      if (this.selected_property?.parent_property_uid) {
        this.selected_property['property_uid'] = this.selected_property?.parent_property_uid;
      }
       if(this.selected_property?.lat){
        this.mapCenter = [this.selected_property.lat, this.selected_property.lon]
      }
    }

  }

  mapLayer: any;
  map: any;
  public mapZoom: any = 16;
  floorDetail: any=null;
  currentFloorSelected: any;
  currentReportView!: number;
  currentReportView$: Subscription = new Subscription();
  public selected_property: any;
  viewType = ReportsViewEnum;
  selectedIndex = 0;
  currentLangID = 1;
  floorData: any;
  public sataliteLayer: any;
  public defaultLayer: any;
  public scaleControl: any;
  public layerControl: any;
  multyGeoJsonLayer:any;
  geoJsonLayer:any;
  unitLayer: any = [];
  unit_uid=null;
  unsubscribe$:Subject<void> = new Subject<void>();
chartView = ReportsChartEnum;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private reportTenantsMapService: ReportTenantsMapService,
    public reportService: ReportService,
    private sharedService: SharedService,
    private userService: UserService,
    private router: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sharedService.language$.pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe(res => {
        let language = this.sharedService.getCurrentLangID();
        this.currentLangID = language;
        if (this.layerControl) {
          this.layerControl.remove();
          var layers = {
            'No layer': L.tileLayer('', {maxZoom: 23,minZoom: this.mapZoom}),
            "Satellite": this.sataliteLayer,
            "OSM <small>(Jawg)</small>": this.defaultLayer,
          };
          this.layerControl = L.control.layers(layers);
          this.layerControl.setPosition(this.currentLangID == 1 ? 'topright' : 'topleft').addTo(this.map);
        }
        if(this.zoomControl) {
          this.zoomControl.remove();
          this.addZoomControl();
        }
      })
      this.initMap();
    }
    if(!this.selected_property?.shop_label) {
      this.selected_property = {
        ...this.selected_property,
        shop_label: this.selected_property.property_name,
        is_property: true
      };
    }
    this.getUnits()

    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      if (this.currentReportView != view) {
        if (this.map && view !== 0) this.map.closePopup();
        this.currentReportView = view;
      }
    });

    this.reportService.showUnitTenantMap$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((value:any)=>{
      this.unit_uid = value.unit_uid;
      let index = this.floorDetail.findIndex((item: any) => item?.floor_uid == value.floor_uid);
      if(index > -1) {
        this.selected_tenant = {
          floor_uid:value.floor_uid,
          tenant_name:value.tenant_name_unit_number
        }
        this.setGeoLayer(index, value.unit_uid);
      }
    })

  }

  getUnits() {
    // ========
    this.sataliteLayer = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
      maxZoom: 21,
      zIndex: 1,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    }).addTo(this.map);
    if (environment.is_production) {
      this.defaultLayer = L.tileLayer('https://tile.jawg.io/c458ee94-1619-468e-bfb3-e315b379a4ce/{z}/{x}/{y}{r}.png?access-token={accessToken}', {
        attribution: '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 21,
        minZoom: this.mapZoom,
        subdomains: 'abcd',
        accessToken: 'O4lo58fpF3zdhkzPQMtrEmKtTZmV4FOlArfe2vlryRpMCoOEfbqJv4ui9ypAxexs'
      });
    } else {
      this.defaultLayer = L.tileLayer(environment.cartoBasemapUrl, {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 21,
        minZoom: this.mapZoom
      });
    }
    let x = {
      zoomControl: false,
      maxZoom: 21,
      minZoom: this.mapZoom
    }
    var layers = {
      'No layer': L.tileLayer('', {maxZoom: 23,minZoom: this.mapZoom}),
      "Satellite": this.sataliteLayer,
      "OSM <small>(Jawg)</small>": this.defaultLayer,
    };
    this.scaleControl = L.control.scale(); //Variable declared for adding of Scale Control on Map
    if (!this.layerControl) {
      this.layerControl = L.control.layers(layers);
      this.layerControl.setPosition(this.currentLangID == 1 ? 'topright' : 'topleft').addTo(this.map);
    }
    //
    // ========
    this.reportTenantsMapService.getUnits(this.selected_property).subscribe(
      {
        next: (res: any) => {
          if (res.status == 200) {
            this.floorDetail = res.data;
            let index = this.floorDetail.findIndex((item: any) => item?.unit_count) !== -1
              ? this.floorDetail.findIndex((item: any) => item?.unit_count)
              : this.floorDetail.findIndex((item: any) => item?.unit_layout?.layout_data);
              if(this.selected_property?.is_property) index =  this.floorDetail.findIndex((item: any) => item?.floor_number  === 0)
              if(this.selected_property?.is_unit_layout) {
                index =  this.floorDetail.findIndex((item: any) => item.floor_uid  == this.selected_property.floor_uid);//this.selected_property.floor_uid
                this.unit_uid = this.selected_property.unit_uid;
                this.setGeoLayer(index, this.selected_property.unit_uid);
                return
              }
            this.setGeoLayer(index)

          } else {
            this.floorDetail = null;
            this.currentFloorSelected = null;
          }
        },
        error: (error: any) => {
          this.floorDetail = null;
          this.currentFloorSelected = null;
        }
      }
    )
  }

  initMap() {
    if (this.map) {
      this.map.off();
      this.map.remove();
    }

    this.map = L.map('tenantsMap', {
      zoomControl: false,
      maxZoom: 21,
      minZoom: this.mapZoom
    }).setView(this.mapCenter, this.mapZoom);

    this.addZoomControl();
    this.map.attributionControl.setPrefix('');
  }

  addZoomControl() {
    this.zoomControl = L.control.zoom({
      position: this.currentLangID == 1 ? 'bottomright' : 'bottomleft'
    }).addTo(this.map);
  }
  setGeoLayer(index = 0, unit_uid=null, is_tab:boolean=false) {
    if(is_tab && this.unit_uid) unit_uid = this.unit_uid;
    this.currentFloorSelected = this.floorDetail[index];
     const activity:activityPayload = {
            userdata: { ...this.currentFloorSelected, property_uid:this.selected_property?.property_uid },
            actionId: actionIdConstants.show_floor_map,
            entity: 'report',
            entityId: this.router.snapshot.queryParams['rid'],
          };
          this.userService.logUserActivity(activity);
    this.selectedIndex = index;
    var that = this;
    if(!this.selected_property?.is_property && !this.selected_property?.is_unit_layout){
       this.unitLayer = this.currentFloorSelected.unit_layout.layout_data?.features.filter((layer: any) => layer.properties.shop_name && layer.properties.shop_name?.toLowerCase() == that.selected_property.shop_label?.toLowerCase())
    } else {
      if(unit_uid){
        this.unitLayer = this.currentFloorSelected.unit_layout.layout_data?.features.filter((layer: any) => layer.properties.unit_uid && layer.properties.unit_uid == unit_uid)
      }
      else {
        this.unitLayer = this.currentFloorSelected.unit_layout.layout_data?.features.filter((layer: any) => layer.properties.shop_name) || [];
        if(!this.unitLayer.length){
          this.unitLayer = this.currentFloorSelected.unit_layout.layout_data?.features;
        }
      }
    }
    if (this.currentFloorSelected.unit_layout.layout_data) {
      if (this.floorData) {
        this.floorData.clearLayers()
      }
      this.floorData = L.geoJSON(this.currentFloorSelected.unit_layout.layout_data, {

        style: function (feature: any) {
          let properties = feature.properties;
          if ((properties.unit_uid == unit_uid) || (properties?.shop_name && properties.shop_name?.toLowerCase() == that.selected_property.shop_label?.toLowerCase())) {
            if(that.selected_property?.is_unit_layout) return that.reportTenantsMapService.filledTenantColor();
            return that.reportTenantsMapService.tenantColor();
          } else if (properties.is_vacant) {
            return that.reportTenantsMapService.vacantColor();
          } else {
            return that.reportTenantsMapService.filledTenantColor();
          }
        }
      }).bindTooltip(function (layer: any) {
          return layer.feature.properties.shop_name || 'Vacant';
        }, {
          direction: `${this.currentLangID == 1 ? 'left' : 'right'}`,
          className: "tenantTT-tip",
        }

        ).addTo(this.map);
        if(this.geoJsonLayer) this.map.removeLayer(this.geoJsonLayer);
        if(this.multyGeoJsonLayer) this.map.removeLayer(this.multyGeoJsonLayer);
      if (this.unitLayer?.length > 1) {
        const parcels = {
          type: 'FeatureCollection',
          features: this.unitLayer
        }
        this.multyGeoJsonLayer = L.geoJSON(parcels, {

          style: function (feature: any) {
            let properties = feature.properties;
            if (properties?.shop_name && properties.shop_name?.toLowerCase() == that.selected_property.shop_label?.toLowerCase()) {
              return that.reportTenantsMapService.tenantColor();
            } else if (properties.is_vacant) {
              return that.reportTenantsMapService.vacantColor();
            } else {
              return that.reportTenantsMapService.filledTenantColor();
            }
          }
        }).bindTooltip(function (layer: any) {
          let shopeName = (!layer.feature.properties.is_vacant && !layer.feature.properties.shop_name) ? 'Unknown': !layer.feature.properties.is_vacant? layer.feature.properties.shop_name:null;
            return shopeName || 'Vacant';
          return layer.feature.properties.shop_name || 'Vacant';
        }, {
          direction: `${this.currentLangID == 1 ? 'left' : 'right'}`,
          className: "tenantTT-tip",
        }).addTo(this.map);
        this.map.fitBounds(this.multyGeoJsonLayer.getBounds());
      } else {
        if(this.unitLayer?.length > 0){
          this.geoJsonLayer = L.geoJSON(this.unitLayer[0], {

            style: function (feature: any) {
              let properties = feature.properties;
              if ((properties.unit_uid == unit_uid) || (properties?.shop_name && properties.shop_name?.toLowerCase() == that.selected_property.shop_label?.toLowerCase())) {
                return that.reportTenantsMapService.tenantColor();
              } else if (properties.is_vacant) {
                return that.reportTenantsMapService.vacantColor();
              } else {
                return that.reportTenantsMapService.filledTenantColor();
              }
            }
          }).bindTooltip(function (layer: any) {
            return layer.feature.properties.shop_name || 'Vacant';
          }, {
            direction: `${this.currentLangID == 1 ? 'left' : 'right'}`,
            className: "tenantTT-tip",
          }).addTo(this.map);
          if(unit_uid){
            this.map.fitBounds(this.geoJsonLayer.getBounds(), {
              animate: true,
              duration: 0.5,
              easeLinearity: 0.25
            });
          }
          else {this.map.fitBounds(this.geoJsonLayer.getBounds());}
        } else {
          this.map.setZoom(19);
        }
      }
    } else {
      if(this.geoJsonLayer) this.map.removeLayer(this.geoJsonLayer);
      if(this.multyGeoJsonLayer) this.map.removeLayer(this.multyGeoJsonLayer);
      this.floorData?.clearLayers()
      this.map.setZoom(19);
    }

  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.off();
      this.map.remove();
      if (this.zoomControl) {
        this.zoomControl.remove();
      }
    }
    if (this.currentReportView$) this.currentReportView$.unsubscribe();
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
